import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CommunityService } from 'src/app/core/services/community.service';
import { SocketService } from 'src/app/core/services/socket.service';
import { Message } from 'src/app/core/models/message';

type TempMessage = Message & { tempId?: string };

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit, OnDestroy {

  messages: TempMessage[] = [];
  filteredMessages: TempMessage[] = [];
  newMessage = '';
  userToken = localStorage.getItem('authToken') || '';
  currentUser: any = {};
  activeUser: any = null;
  previewImageUrl: string | null = null;
  showSearch = false;
  searchQuery = '';
  imageURL = 'http://localhost:5000/';

  showEmojiPicker = false;
  emojis: string[] = [
    // 😄 Smileys & Emotions
    '😀', '😁', '😂', '🤣', '😃', '😄', '😅', '😆', '😉', '😊', '😋', '😎', '😍', '😘', '🥰', '😗', '😙', '😚',
    '🙂', '🤗', '🤩', '🤔', '🤨', '😐', '😑', '😶', '🙄', '😏', '😣', '😥', '😮', '🤐', '😯', '😪', '😫', '🥱',
    '😴', '😌', '😛', '😜', '😝', '🤤', '😒', '😓', '😔', '😕', '🙃', '🫠', '🤑', '😲', '☹️', '🙁', '😖', '😞',
    '😟', '😤', '😢', '😭', '😦', '😧', '😨', '😩', '🤯', '😬', '😰', '😱', '🥵', '🥶', '😳', '🤪', '😵', '😡',
    '😠', '🤬', '😷', '🤒', '🤕', '🤢', '🤮', '🤧', '🥴', '😇', '🥳', '🥸', '😈', '👿', '💀', '☠️', '👻', '👽',
    '🤖', '💩',

    // 👋 Gestures & People
    '👋', '🤚', '🖐️', '✋', '🖖', '👌', '🤌', '🤏', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '👇', '☝️', '✋',
    '✍️', '👏', '🙌', '👐', '🤲', '🙏', '💅', '🤳', '💪', '🦵', '🦶', '👂', '👃', '🧠', '🦷', '👀', '👁️', '👅', '👄',
    '🫶', '🤝', '✊', '👊', '🤛', '🤜', '💋',

    // ❤️ Hearts & Love
    '❤️', '🩷', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❤️‍🔥', '❤️‍🩹', '💕', '💞', '💓', '💗', '💖',
    '💘', '💝', '💟', '❣️',

    // 🐶 Animals & Nature
    '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮', '🐷', '🐸', '🐵', '🐔', '🐧', '🐦', '🐤',
    '🐣', '🦆', '🦅', '🦉', '🦇', '🐺', '🐗', '🐴', '🦄', '🐝', '🐛', '🦋', '🐌', '🐞', '🐜', '🕷️', '🦂', '🐢',
    '🐍', '🦎', '🦖', '🦕', '🐙', '🦑', '🦀', '🐡', '🐠', '🐟', '🐬', '🐳', '🐋', '🦈', '🐊', '🐅', '🐆', '🦓',
    '🦍', '🦧', '🐘', '🦛', '🦏', '🐪', '🐫', '🦒', '🦘', '🐃', '🐂', '🐄', '🐎', '🐖', '🐏', '🐑', '🦙', '🐐',
    '🦌', '🐕', '🐩', '🐈', '🐓', '🦃', '🦚', '🦜', '🦢', '🕊️', '🐇', '🦝', '🦨', '🦡', '🦫', '🦦', '🐁', '🐀',

    // 🍔 Food & Drink
    '🍏', '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🫐', '🍈', '🍒', '🍑', '🥭', '🍍', '🥥', '🥝',
    '🍅', '🍆', '🥑', '🥦', '🥬', '🥒', '🌶️', '🌽', '🥕', '🧄', '🧅', '🥔', '🍠', '🥐', '🥯', '🍞', '🥖',
    '🥨', '🧀', '🥚', '🍳', '🥞', '🧇', '🥓', '🥩', '🍗', '🍖', '🌭', '🍔', '🍟', '🍕', '🥪', '🌮', '🌯',
    '🥙', '🧆', '🥗', '🍝', '🍜', '🍲', '🍛', '🍣', '🍱', '🥟', '🍤', '🍙', '🍚', '🍘', '🍢', '🍡', '🍧',
    '🍨', '🍦', '🥧', '🧁', '🍰', '🎂', '🍮', '🍭', '🍬', '🍫', '🍿', '🍩', '🍪', '🥛', '🧃', '☕', '🍵',
    '🧉', '🍺', '🍻', '🍷', '🥂', '🥃', '🍸', '🍹', '🧊',

    // 🚗 Travel & Places
    '🚗', '🚕', '🚙', '🚌', '🚎', '🏎️', '🚓', '🚑', '🚒', '🚐', '🚚', '🚛', '🚜', '🏍️', '🛵', '🛺', '🚲',
    '🛴', '🚏', '🛣️', '🛤️', '⛽', '🚨', '🚥', '🚦', '🚧', '🛑', '🚢', '🛳️', '⛴️', '🚤', '⛵', '🛶', '🚁', '🛩️',
    '✈️', '🛫', '🛬', '🚀', '🪂', '🗺️', '🗽', '🗼', '🏰', '🏯', '🏟️', '🎡', '🎢', '🎠', '🏖️', '🏝️', '🏜️',
    '🌋', '🗻', '🏔️', '🏕️', '🏡', '🏠', '🏢', '🏬', '🏣', '🏤', '🏥', '🏦', '🏪', '🏫', '🏩', '💒',

    // 🎁 Activities & Objects
    '🎃', '🎄', '🎆', '🎇', '✨', '🎈', '🎉', '🎊', '🎋', '🎍', '🎎', '🎏', '🎐', '🎑', '🎀', '🎁',
    '🎂', '🍰', '🧁', '🍭', '🍬', '🍫', '🎪', '🎭', '🎨', '🎬', '🎤', '🎧', '🎼', '🎹', '🥁', '🎷', '🎺',
    '🎸', '🎻', '🎮', '🕹️', '🎲', '♟️', '🎯', '🎳', '🎽', '🥇', '🥈', '🥉', '🏆', '🏅', '🎖️',

    // 💡 Objects
    '💡', '🔦', '🕯️', '💻', '🖥️', '🖨️', '🖱️', '🖲️', '💾', '📱', '📲', '☎️', '📞', '📟', '📠',
    '📷', '📸', '🎥', '📺', '📻', '📡', '⌚', '⏰', '⏱️', '⏲️', '🕰️', '🔋', '🔌', '💵', '💴', '💶', '💷',
    '💳', '💎', '⚖️', '🧰', '🔧', '🔨', '🪓', '🔩', '⚙️', '🪛', '🧱', '🪚', '🪜', '⚗️', '🧪', '🧫', '🧬',

    // 🔣 Symbols
    '❤️', '💔', '💯', '💢', '💥', '💫', '💦', '💨', '🕳️', '💬', '👁️‍🗨️', '🗨️', '🗯️', '💭', '💤',
    '✅', '❌', '❗', '❓', '⚠️', '🚫', '🔞', '🔒', '🔓', '🔏', '🔐', '🔑', '🗝️', '🪙', '💰', '🏧', '💲',
    '♻️', '⚙️', '🔆', '🔅', '🔱', '⚜️', '🔰', '🏁', '🚩', '🎌', '🏳️', '🏴', '🏳️‍🌈', '🏴‍☠️'
  ];


  constructor(
    private communityService: CommunityService,
    private socketService: SocketService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('authenticatedUser') || '{}');
    this.socketService.connect(this.userToken);
    this.loadMessages();

    this.socketService.onNewMessage((msg: TempMessage) => {
      const tempMatch = this.messages.findIndex(m => m.tempId && msg.tempId && m.tempId === msg.tempId);
      const alreadyExists = this.messages.some(m => m._id === msg._id);

      if (tempMatch !== -1) {
        this.messages[tempMatch] = msg;
      } else if (!alreadyExists && msg.sender._id !== this.currentUser._id) {
        this.messages.push(msg);
      }

      this.filteredMessages = [...this.messages];
      this.cdr.detectChanges();
      this.scrollToBottom();
    });
  }

  toggleSearch(): void {
    this.showSearch = !this.showSearch;
    if (!this.showSearch) {
      this.searchQuery = '';
      this.filteredMessages = [...this.messages];
    }
  }

  filterMessages(): void {
    const query = this.searchQuery.trim().toLowerCase();
    if (!query) {
      this.filteredMessages = [...this.messages];
      return;
    }

    this.filteredMessages = this.messages.filter(msg =>
      msg.content?.toLowerCase().includes(query)
    );

    // Scroll first match into view (optional)
    setTimeout(() => {
      const firstMatch = document.querySelector('.message-item');
      if (firstMatch) firstMatch.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }

  uploadFile(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('attachment', file); // ✅ correct field name

    this.previewImageUrl = URL.createObjectURL(file);

    this.communityService.uploadAttachment(formData).subscribe({
      next: (res: any) => {
        if (res.success && res.message?.attachment?.fileUrl) {
          const newMsg: TempMessage = {
            _id: res.message._id,
            content: res.message.content,
            createdAt: res.message.createdAt,
            updatedAt: res.message.updatedAt || new Date().toISOString(), // ✅ fix here
            sender: res.message.sender,
            attachment: res.message.attachment.fileUrl,
            deliveredTo: [],
            seenBy: [],
            isEdited: false,
            isDeleted: false
          };

          this.messages.push(newMsg);
          this.filteredMessages = [...this.messages];
          this.scrollToBottom();
        }
        this.previewImageUrl = null;
      },
      error: (err) => {
        console.error('Upload failed:', err);
        this.previewImageUrl = null;
      }
    });
  }

  isImageFile(fileUrl: string): boolean {
    return /\.(jpe?g|png|gif|bmp|webp|svg)$/i.test(fileUrl);
  }

  openImagePreview(url: string) {
    this.previewImageUrl = url;
  }

  closeImagePreview() {
    this.previewImageUrl = null;
  }

  loadMessages(): void {
    this.communityService.getAllMessages().subscribe({
      next: (res: any) => {
        if (res.success) {
          this.messages = res.messages.map((msg: any) => ({
            ...msg,
            attachment: msg.attachment
              ? this.communityService.imageURL + msg.attachment  // ✅ full image path
              : null
          }));
          this.filteredMessages = [...this.messages];
          this.cdr.detectChanges();
          this.scrollToBottom();
        }
      },
      error: (err: any) => console.error('Error loading messages', err)
    });
  }


  sendMessage(): void {
    if (!this.newMessage.trim()) return;

    const tempId = Date.now().toString();
    const messageText = this.newMessage.trim();
    const senderData = this.currentUser || {};

    const tempMsg: TempMessage = {
      _id: `temp-${tempId}`,
      tempId,
      content: messageText,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      sender: {
        _id: senderData._id || 'self',
        name: senderData.name || 'You',
        email: senderData.email || '',
        profilePicture: senderData.profilePicture || 'assets/default-avatar.png'
      },
      deliveredTo: [],
      seenBy: [],
      isEdited: false,
      isDeleted: false
    };

    this.messages = [...this.messages, tempMsg];
    this.filteredMessages = [...this.messages];
    this.cdr.detectChanges();
    this.scrollToBottom();

    this.socketService.sendMessage({ content: messageText, tempId });

    this.communityService.sendMessage(messageText).subscribe({
      next: () => { },
      error: (err: any) => console.error('Failed to save message', err)
    });

    this.newMessage = '';
  }

  scrollToBottom(): void {
    setTimeout(() => {
      const chatBox = document.querySelector('.chat-box');
      if (chatBox) chatBox.scrollTop = chatBox.scrollHeight;
    }, 50);
  }

  ngOnDestroy(): void {
    this.socketService.disconnect();
  }

  toggleEmojiPicker() {
    this.showEmojiPicker = !this.showEmojiPicker;
  }

  addEmoji(emoji: string) {
    this.newMessage = (this.newMessage || '') + emoji;
    this.showEmojiPicker = false;
  }
}
